// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getErrorBackground = (data: any, name: string) => {
  if (data?.[name]?.details?.[0]?.message) {
    return "text-left bg-red-500 text-white p-2";
  }
  return "text-left";
};
